<template>
  <div class="background_news">
    <div class="news_index_text">
      <p style="font-size: 24px;margin-bottom: 1vh" class="animate__fadeInUp animate__animated">Our Advantages</p>
      <p style="font-size: 36px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-1s">Over the
        past 12 years, SIG has focused on technology/media,</p>
      <p style="font-size: 36px; margin-bottom: 5vh;" class="animate__fadeInUp animate__animated animate__delay-1s">
        consumer/modern services, healthcare/green technologies.</p>
      <p style="font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">We are interested in new
        business models, and we pay close attention to technology innovations,</p>
      <p style="font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">but most important of
        all, we value the gift and potential of entrepreneurs.</p>
      <div style="padding-top: 2vh" class="animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "News_index_en",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.news_index_text {
  padding-top: 34vh;
  text-align: left;
  margin-left: 12vw;
}

.background_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}

</style>